export default __webpack_public_path__ + "static/stacked-bar-b87caf77fa496710ecea88cfd473ba56.png";